// Public /docs routes (unauthenticated)
export const docsRoutes = [
    {
        path: '/docs',
        component: () => import('@/features/docs/views/DocsRouterView.vue'),
        children: [
            {
                path: '',
                component: () => import('@/features/docs/views/DocsIndexView.vue'),
                name: 'docs-index',
            },
            {
                path: 'keys',
                component: () => import('@/features/docs/views/DocsKeysRouterView.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('@/features/docs/views/DocsKeysIndexView.vue'),
                        name: 'docs-keys-index',
                    },
                ],
            },
            {
                path: 'apis',
                component: () => import('@/features/docs/views/DocsApisRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'docs-apis',
                        redirect: { name: 'docs-index' },
                    },
                    {
                        path: ':id/:env',
                        component: () => import('@/features/docs/views/DocsApisIndexView.vue'),
                        children: [
                            { path: '', name: 'docs-apis-viewer' },
                            { path: ':section?', name: 'docs-apis-viewer-section' },
                        ],
                    },
                ],
            },
            {
                path: 'no-access',
                component: () => import('@/features/docs/views/DocsNoAccessView.vue'),
                name: 'docs-no-access',
            },
        ],
    },
]

// Authenticated api-docs routes (children of ViewAuthenticated)
export const apiDocsRoutes = [
    {
        path: 'api-docs',
        component: () => import('@/features/docs/views/ApiDocsRouterView.vue'),
        children: [
            {
                path: '',
                component: () => import('@/features/docs/views/DocsIndexView.vue'),
                name: 'api-docs-index',
            },
            {
                path: 'keys',
                component: () => import('@/features/docs/views/ApiDocsKeysRouterView.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('@/features/docs/views/DocsKeysIndexView.vue'),
                        name: 'api-docs-keys-index',
                    },
                ],
            },
            {
                path: 'apis',
                component: () => import('@/features/docs/views/DocsApisRouterView.vue'),
                children: [
                    {
                        path: '',
                        name: 'api-docs-apis',
                        redirect: { name: 'api-docs-index' },
                    },
                    {
                        path: ':id/:env',
                        component: () => import('@/features/docs/views/DocsApisIndexView.vue'),
                        children: [
                            { path: '', name: 'api-docs-apis-viewer' },
                            { path: ':section?', name: 'api-docs-apis-viewer-section' },
                        ],
                    },
                ],
            },
            {
                path: 'no-access',
                component: () => import('@/features/docs/views/DocsNoAccessView.vue'),
                name: 'api-docs-no-access',
            },
        ],
    },
]
